import { format, startOfDay, endOfDay, startOfWeek, endOfWeek, startOfMonth, endOfMonth, addDays } from 'date-fns';
import { DateRangeView } from '@components/common/DateRangeNavigator.tsx';

/** Межі періоду (YYYY-MM-DD, включно) для заданого виду (`DateRangeView`) навколо `date`. Тиждень — з понеділка. */
export function getDateRange(date: Date, view: DateRangeView): { from: string; to: string } {
  let from: Date;
  let to: Date;
  switch (view) {
    case 'day':
      from = startOfDay(date);
      to = endOfDay(date);
      break;
    case 'week':
      from = startOfWeek(date, { weekStartsOn: 1 });
      to = endOfWeek(date, { weekStartsOn: 1 });
      break;
    case '2weeks': {
      const start = startOfWeek(date, { weekStartsOn: 1 });
      from = start;
      to = endOfDay(addDays(start, 13));
      break;
    }
    case 'month':
      from = startOfMonth(date);
      to = endOfMonth(date);
      break;
    default:
      from = startOfDay(date);
      to = endOfDay(date);
  }
  return {
    from: format(from, 'yyyy-MM-dd'),
    to: format(to, 'yyyy-MM-dd'),
  };
}
